import { openPhone } from 'shared/map-search/actions/callPopup';
import { addFavorite, deleteFavorite } from 'shared/map-search/actions/favorites';
import { requestAuthentication } from 'shared/map-search/actions/requestAuthentication';
import { TThunkDispatch } from 'shared/map-search/types/redux';

import { EAddFavoritesActionTypes, EDeleteFavoritesActionTypes } from '../actions/favorites';
import { EPhoneActionType } from '../actions/phone';
import { ERequestAuthenticationActionType } from '../actions/requestAuthentication';
import { IReduxActionMessage } from '../types';

export function reduxActionMessageHandler(message: IReduxActionMessage, dispatch: TThunkDispatch) {
  switch (message.value.type) {
    case EDeleteFavoritesActionTypes.Failure:
    case EAddFavoritesActionTypes.Request:
      dispatch(addFavorite(message.value.payload.offerId));
      break;
    case EDeleteFavoritesActionTypes.Request:
    case EAddFavoritesActionTypes.Failure:
      dispatch(deleteFavorite(message.value.payload.offerId));
      break;
    case EPhoneActionType.Open:
      dispatch(
        openPhone({
          builders: message.value.payload.builders,
          sellers: message.value.payload.sellers,
          gaLabel: message.value.payload.gaLabel,
          newbuildingId: message.value.payload.newbuildingId,
        }),
      );
      break;
    case ERequestAuthenticationActionType.Modal:
      dispatch(requestAuthentication(message.value.payload));
      break;
  }
}
